module.exports = __webpack_public_path__ + "img/wechat-login.6915dffb.png";